// extracted by mini-css-extract-plugin
export default {"w-full":"NewClasse_w-full__755i0","row":"NewClasse_row__mMaFb","col":"NewClasse_col__z1ICG","card":"NewClasse_card__TBbl-","button":"NewClasse_button__r+2Bv"};